var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","open-delay":500},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":_vm.download}},on),[_c('v-icon',[_vm._v("mdi-download")])],1)]}}])},[_vm._v(" Download log ")])
}
var staticRenderFns = []

export { render, staticRenderFns }